export const siteMetaSetting = {
  title: "トレカKINGDOM",
  description: "トレカKINGDOM",
};
